import { render, staticRenderFns } from "./importMeterWaterFee.vue?vue&type=template&id=5b1d445a"
import script from "./importMeterWaterFee.vue?vue&type=script&lang=js"
export * from "./importMeterWaterFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports